/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zeitgeist_chain_about = () => `Zeitgeist is a decentralized network designed for establishing, wagering on, and settling prediction markets, enabling users to craft intricate financial agreements on a wide range of subjects. The platform's native currency, ZTG, serves to influence the network's direction and acts as a final recourse for dispute resolution within its decentralized court system.`
